module.exports = __webpack_public_path__ + "img/personalized-ia.b6410048.svg";